import { render, staticRenderFns } from "./VariantSifterCanvas.vue?vue&type=template&id=428e3970&scoped=true&"
import script from "./VariantSifterCanvas.vue?vue&type=script&lang=js&"
export * from "./VariantSifterCanvas.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterCanvas.vue?vue&type=style&index=0&id=428e3970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428e3970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428e3970')) {
      api.createRecord('428e3970', component.options)
    } else {
      api.reload('428e3970', component.options)
    }
    module.hot.accept("./VariantSifterCanvas.vue?vue&type=template&id=428e3970&scoped=true&", function () {
      api.rerender('428e3970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterCanvas.vue"
export default component.exports